var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"checkbox-container"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.shouldBeChecked,"value":_vm.value},on:{"change":_vm.updateInput}}),_c('span',{staticClass:"checkmark"}),_c('span',{staticClass:"text-sm pl-2",class:{ 'font-semibold': _vm.bold }},[_vm._v(_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }